(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lavizah-hero-slider"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.lavizah-slider').forEach((slider) => {

    const slides = slider.querySelectorAll('.lavizah-slide');

    if (slides.length <= 1) return;

    let current = 0;
    let timer;

    const speed =
      Number(slider.dataset.speed) || 4000;


    function showSlide(index) {

      slides.forEach((slide, i) => {

        slide.classList.remove(
          'active',
          'prev'
        );

        if (i === index) {

          slide.classList.add('active');

        } else if (
          i ===
          (index - 1 + slides.length) %
          slides.length
        ) {

          slide.classList.add('prev');

        }

      });

    }


    function nextSlide() {

      current++;

      if (current >= slides.length) {
        current = 0;
      }

      showSlide(current);

    }


    function startSlider() {

      clearInterval(timer);

      timer =
        setInterval(
          nextSlide,
          speed
        );

    }


    function stopSlider() {

      clearInterval(timer);

    }




    showSlide(0);

    startSlider();

  });

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
